import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import MenuItem from 'material-ui/MenuItem';
import { Link, browserHistory } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import AdBlockDetect from 'react-ad-block-detect';
import Measure from 'react-measure';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton, Spinner, FormProvider } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { setLeadAdBuilderValue, setLeadAdBuilderBullet, fetchExistingForms, fetchFormDetails, saveLeadForm, createLeadGenAd, clearLeadFormData, clearAdBuilderForOrg } from 'redux/modules/adBuilder';
import { Intro, Questions, PrivacyPolicy, ThankYou } from 'components/AdBuilder/FormBuilder';
import { LeadFormPreview } from 'components/AdBuilder/LeadFormPreviews';
import Popover from 'material-ui/Popover';
import Toggle from 'material-ui/Toggle';
import Paper from 'material-ui/Paper';
import * as styles from './LeadFormBuilder.scss';
import leadFormValidator from '../../helpers/leadFormValidator';
import { initialLeadBuilderState, toRedux as convertFormToRedux } from '../../helpers/leadFormConverter';
import { changeField, clearForm, mergeForm, asyncChangeField } from 'redux/modules/forms';

var validator = require('validator');

var LeadFormBuilder = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var leadBuilderForm = state.forms && state.forms["lead_builder_org_".concat(orgId)] ? _objectSpread({}, state.forms["lead_builder_org_".concat(orgId)]) : null;
  var validationErrors = leadBuilderForm && leadBuilderForm.validationErrors ? leadBuilderForm.validationErrors : null;
  return {
    organization: state.organization.current,
    formValues: state.adBuilder && state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)] : {},
    savedAudiences: state.ads && state.ads.savedAudiences && !!state.ads.savedAudiences ? state.ads.savedAudiences : [],
    theme: state.theme,
    builder: leadBuilderForm,
    builderFormName: "lead_builder_org_".concat(orgId),
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    introValidationErrors: validationErrors ? validationErrors.intro : [],
    questionsValidationErrors: validationErrors ? validationErrors.questions : [],
    privacyPolicyValidationErrors: validationErrors ? validationErrors.privacyPolicy : [],
    thankYouValidationErrors: validationErrors ? validationErrors.thankYou : [],
    formValidationErrors: validationErrors ? validationErrors.form : [],
    adAccountConnectedInstagramId: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adAccountConnectedInstagramId : null
  };
}, {
  setLeadAdBuilderValue: setLeadAdBuilderValue,
  setLeadAdBuilderBullet: setLeadAdBuilderBullet,
  fetchExistingForms: fetchExistingForms,
  fetchFormDetails: fetchFormDetails,
  saveLeadForm: saveLeadForm,
  createLeadGenAd: createLeadGenAd,
  clearLeadFormData: clearLeadFormData,
  clearAdBuilderForOrg: clearAdBuilderForOrg,
  changeField: changeField,
  clearForm: clearForm,
  mergeForm: mergeForm,
  asyncChangeField: asyncChangeField
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LeadFormBuilder, _Component);

  var _super = _createSuper(LeadFormBuilder);

  function LeadFormBuilder(props) {
    var _this;

    _classCallCheck(this, LeadFormBuilder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getExistingForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, builderFormName, orgId, socialAccountId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, builderFormName = _this$props.builderFormName, orgId = _this$props.organization.id, socialAccountId = _this$props.adAccount.socialAccountId;
              _context2.prev = 1;

              _this.props.changeField(builderFormName, 'fetchingForms', true);

              _context2.next = 5;
              return _this.props.asyncChangeField(builderFormName, 'existingLeadForms', /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
                  var _yield$client$get, data;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return client.get("/org/".concat(orgId, "/socialAccount/").concat(socialAccountId, "/leadForms"));

                        case 2:
                          _yield$client$get = _context.sent;
                          data = _yield$client$get.data;
                          return _context.abrupt("return", data);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 5:
              _this.props.changeField(builderFormName, 'fetchingForms', false);

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

              _this.props.changeField(builderFormName, 'fetchingForms', false);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props2, builderFormName, orgId, socialAccountId, formData, data;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, builderFormName = _this$props2.builderFormName, orgId = _this$props2.organization.id, socialAccountId = _this$props2.adAccount.socialAccountId, formData = _this$props2.builder;
              _context4.prev = 1;

              _this.props.changeField(builderFormName, 'isSavingForm', true);

              _context4.next = 5;
              return _this.props.asyncChangeField(builderFormName, 'createdForm', /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
                  var _yield$client$post, data;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return client.post("/org/".concat(orgId, "/socialAccount/").concat(socialAccountId, "/leadForm"), {
                            data: _objectSpread({}, formData)
                          });

                        case 2:
                          _yield$client$post = _context3.sent;
                          data = _yield$client$post.data;
                          return _context3.abrupt("return", data);

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 5:
              data = _context4.sent;

              _this.props.changeField(builderFormName, 'isSavingForm', false);

              if (_this.props.onCreated) {
                _this.props.onCreated(data);
              }

              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              console.error(_context4.t0);

              _this.props.changeField(builderFormName, 'isSavingForm', false);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderFormSettings", function () {
      var languages = [{
        key: 'en_US',
        title: 'English (US)'
      }, {
        key: 'en_GB',
        title: 'English (UK)'
      }];
      var sharingTooltip = "By default, only people who are delivered your ad directly will be able to see and submit this form.\n    Select \"Open\" to let people share this form with friends and allow submissions from people tagged in the comments.";
      return /*#__PURE__*/React.createElement("section", {
        style: {
          margin: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, "Form Language"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, _this.props.builder && /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.props.builder.formLanguage,
        fullWidth: true,
        onChange: function onChange(e, key, value) {
          _this.props.changeField(_this.props.builderFormName, 'formLanguage', value);
        }
      }, languages.map(function (obj, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: obj.key,
          primaryText: obj.title
        });
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, "Sharing"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, /*#__PURE__*/React.createElement("small", null, sharingTooltip), _this.props.builder && /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "formSharing",
        valueSelected: _this.props.builder.blockDisplayForNonTargetedViewer ? 'restricted' : 'open',
        style: {
          marginTop: 20
        },
        onChange: function onChange(e, value) {
          _this.props.changeField(_this.props.builderFormName, 'blockDisplayForNonTargetedViewer', value === 'restricted');
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "restricted",
        label: "Restricted"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "open",
        label: "Open"
      })))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormContentIntro", function (validationErrors) {
      return /*#__PURE__*/React.createElement(Intro, {
        builder: _this.props.builder,
        changeField: function changeField(field, value) {
          _this.props.changeField(_this.props.builderFormName, field, value);
        },
        asyncChangeField: function asyncChangeField(field, promise) {
          return _this.props.asyncChangeField(_this.props.builderFormName, field, promise);
        },
        validationErrors: validationErrors
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormContentQuestions", function (validationErrors) {
      return /*#__PURE__*/React.createElement(Questions, {
        builder: _this.props.builder,
        changeField: function changeField(field, value) {
          _this.props.changeField(_this.props.builderFormName, field, value);
        },
        asyncChangeField: function asyncChangeField(field, promise) {
          return _this.props.asyncChangeField(_this.props.builderFormName, field, promise);
        },
        validationErrors: validationErrors
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormContentPrivacy", function (validationErrors) {
      return /*#__PURE__*/React.createElement(PrivacyPolicy, {
        builder: _this.props.builder,
        changeField: function changeField(field, value) {
          _this.props.changeField(_this.props.builderFormName, field, value);
        },
        asyncChangeField: function asyncChangeField(field, promise) {
          return _this.props.asyncChangeField(_this.props.builderFormName, field, promise);
        },
        validationErrors: validationErrors
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormContentThankYou", function (validationErrors) {
      return /*#__PURE__*/React.createElement(ThankYou, {
        builder: _this.props.builder,
        changeField: function changeField(field, value) {
          _this.props.changeField(_this.props.builderFormName, field, value);
        },
        asyncChangeField: function asyncChangeField(field, promise) {
          return _this.props.asyncChangeField(_this.props.builderFormName, field, promise);
        },
        validationErrors: validationErrors
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormContent", function (validatorResult) {
      var sections = [{
        id: 'leadForm_0',
        label: function label() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '40px'
            }
          }, validatorResult.intro.length > 0 && /*#__PURE__*/React.createElement("i", {
            className: "fa fa-times-circle",
            "aria-hidden": "true",
            style: {
              color: 'red'
            }
          }), ' ', "Intro (optional)", ' ', _this.props.builder && /*#__PURE__*/React.createElement(Toggle, {
            toggled: _this.props.builder.introEnabled,
            style: {
              display: 'inline-block',
              width: 'auto'
            },
            onToggle: function onToggle(e, val) {
              return _this.props.changeField(_this.props.builderFormName, 'introEnabled', val);
            }
          }));
        },
        content: _this.renderFormContentIntro(validatorResult.intro),
        opened: _this.props.builder && _this.props.builder.contentAccordionTab === 0
      }, {
        id: 'leadForm_1',
        label: function label() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '40px'
            }
          }, validatorResult.questions.length > 0 && /*#__PURE__*/React.createElement("i", {
            className: "fa fa-times-circle",
            "aria-hidden": "true",
            style: {
              color: 'red'
            }
          }), ' ', "Questions");
        },
        content: _this.renderFormContentQuestions(validatorResult.questions),
        opened: _this.props.builder && _this.props.builder.contentAccordionTab === 1
      }, {
        id: 'leadForm_2',
        label: function label() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '40px'
            }
          }, validatorResult.privacyPolicy.length > 0 && /*#__PURE__*/React.createElement("i", {
            className: "fa fa-times-circle",
            "aria-hidden": "true",
            style: {
              color: 'red'
            }
          }), ' ', "Privacy Policy");
        },
        content: _this.renderFormContentPrivacy(validatorResult.privacyPolicy),
        opened: _this.props.builder && _this.props.builder.contentAccordionTab === 2
      }, {
        id: 'leadForm_3',
        label: function label() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '40px'
            }
          }, validatorResult.thankYou.length > 0 && /*#__PURE__*/React.createElement("i", {
            className: "fa fa-times-circle",
            "aria-hidden": "true",
            style: {
              color: 'red'
            }
          }), ' ', "Thank You Screen");
        },
        content: _this.renderFormContentThankYou(validatorResult.thankYou),
        opened: _this.props.builder && _this.props.builder.contentAccordionTab === 3
      }, {
        id: 'leadForm_4',
        label: 'Form Settings',
        content: _this.renderFormSettings(),
        opened: _this.props.builder && _this.props.builder.contentAccordionTab === 4
      }];
      return /*#__PURE__*/React.createElement(Accordion, {
        sections: sections,
        onClick: _this.handleContentAccordionClick
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleContentAccordionClick", function (_ref5) {
      var target = _ref5.target;
      console.log('in handleContentAccordionClick');

      if (_this.props.builder && _this.props.builder.hasOwnProperty('contentAccordionTab') && _this.props.builder.contentAccordionTab === parseInt(target.id)) {
        _this.props.changeField(_this.props.builderFormName, 'contentAccordionTab', -1);
      } else {
        _this.props.changeField(_this.props.builderFormName, 'contentAccordionTab', parseInt(target.id.split('_')[1]));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "prettyPrintKnownErrors", function (errStr) {
      switch (errStr) {
        case '(#192) Param thank_you_page[business_phone_number] is not a valid phone number.':
          return 'The Business Phone Number in the Thank You Screen section is not valid. Please enter a valid phone number in the format "X(XXX) XXX-XXXX" and try again.';

        default:
          return errStr;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "canContinue", function () {
      var adDetails = _this.props.adDetails;

      if (_this.state.isCreating) {
        return false;
      }

      return !!adDetails.description;
    });

    _defineProperty(_assertThisInitialized(_this), "renderLeftPanel", function (validatorResult) {
      var builder = _this.props.builder;
      return /*#__PURE__*/React.createElement("div", null, _this.props.formValidationErrors.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "There are errors in this section.")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("ul", null, _this.props.formValidationErrors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            color: 'red'
          }
        }, e);
      })))) : null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure() {
          _this.setState({
            _: new Date().getTime()
          });
        },
        whitelist: ['width', 'height'],
        useClone: true
      }, _this.renderFormContent(validatorResult)))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreationChoices", function () {
      return [/*#__PURE__*/React.createElement("div", {
        className: styles.formChoiceWrap,
        key: "newform_choice"
      }, /*#__PURE__*/React.createElement(Paper, {
        className: styles.formChoiceBox,
        zDepth: 2
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: 55,
          padding: '1rem'
        },
        className: "fa fa-file-text",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          fontWeight: '400',
          fontSize: 22
        }
      }, "New form"), /*#__PURE__*/React.createElement("p", null, "Create a new form and enter in all new information."), /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginTop: 32
        },
        secondary: true,
        disabled: !!_this.props.builder.loadingRemoteForm,
        label: "Select",
        onClick: function onClick() {
          _this.props.changeField(_this.props.builderFormName, 'isCreatingNewForm', true);

          _this.props.changeField(_this.props.builderFormName, 'step', 1);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.formChoiceWrap,
        key: "dupform_choice"
      }, /*#__PURE__*/React.createElement(Paper, {
        className: styles.formChoiceBox,
        zDepth: 2
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: 55,
          padding: '1rem'
        },
        className: "fa fa-files-o",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          fontWeight: '400',
          fontSize: 22
        }
      }, "Duplicate an Existing Form"), /*#__PURE__*/React.createElement("p", null, "Duplicate one of your existing forms and change only what you want."), !!_this.props.builder.loadingRemoteForm && /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative'
        },
        center: true
      }), (_this.props.builder.fetchingForms || _this.props.builder.existingLeadForms.length > 0) && !_this.props.builder.loadingRemoteForm && /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.props.builder.selectedExistingFormId,
        fullWidth: true,
        disabled: _this.props.builder.fetchingForms,
        autoWidth: false,
        style: {
          width: '100%'
        },
        onChange: function onChange(e, key, value) {
          _this.props.changeField(_this.props.builderFormName, 'loadingRemoteForm', true);

          _this.props.changeField(_this.props.builderFormName, 'step', 1);

          _this.props.fetchFormDetails(_this.props.organization.id, _this.props.adAccount.socialAccountId, value).then(function (_ref6) {
            var data = _ref6.data;
            var reduxStructure = convertFormToRedux(data);

            _this.props.mergeForm(_this.props.builderFormName, _objectSpread(_objectSpread({}, reduxStructure), {}, {
              loadingRemoteForm: false,
              step: 1
            }));
          });
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: -1,
        primaryText: "Select form"
      }), _this.props.builder.existingLeadForms.map(function (form) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: form.id,
          primaryText: form.name
        });
      })), !_this.props.builder.fetchingForms && _this.props.builder.existingLeadForms.length === 0 && /*#__PURE__*/React.createElement("p", null, "You do not have any existing lead forms yet."), _this.props.isLoadingFormDetail && /*#__PURE__*/React.createElement(Spinner, null))), /*#__PURE__*/React.createElement("div", {
        className: styles.formChoiceWrap,
        key: "useform_choice"
      }, /*#__PURE__*/React.createElement(Paper, {
        className: styles.formChoiceBox,
        zDepth: 2
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: 55,
          padding: '1rem'
        },
        className: "fa fa-folder-open",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          fontWeight: '400',
          fontSize: 22
        }
      }, "Use Existing Form"), /*#__PURE__*/React.createElement("p", null, "Use a form you've already created."), (!!_this.props.builder.loadingRemoteForm || _this.props.isCreatingAd || _this.props.builder.isSavingForm) && /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative'
        },
        center: true
      }), (_this.props.builder.fetchingForms || _this.props.builder.existingLeadForms.length > 0) && !_this.props.isCreatingAd && !_this.props.builder.isSavingForm && !_this.props.builder.loadingRemoteForm && /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.props.builder.selectedExistingFormId,
        fullWidth: true,
        disabled: _this.props.builder.fetchingForms,
        autoWidth: false,
        style: {
          width: '100%'
        },
        onChange: function onChange(e, key, value) {
          _this.props.changeField(_this.props.builderFormName, 'loadingRemoteForm', true);

          _this.props.fetchFormDetails(_this.props.organization.id, _this.props.adAccount.socialAccountId, value).then( /*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
              var data;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      data = _ref7.data;
                      _context5.prev = 1;
                      console.log(data);

                      _this.props.changeField(_this.props.builderFormName, 'createdForm.id', data.id);

                      _context5.next = 6;
                      return _this.props.onCreated(data);

                    case 6:
                      _this.props.changeField(_this.props.builderFormName, 'loadingRemoteForm', false);

                      _context5.next = 13;
                      break;

                    case 9:
                      _context5.prev = 9;
                      _context5.t0 = _context5["catch"](1);
                      console.error(_context5.t0);

                      _this.props.changeField(_this.props.builderFormName, 'loadingRemoteForm', false);

                    case 13:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[1, 9]]);
            }));

            return function (_x3) {
              return _ref8.apply(this, arguments);
            };
          }());
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: -1,
        primaryText: "Select form"
      }), _this.props.builder.existingLeadForms.map(function (form) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: form.id,
          primaryText: form.name
        });
      })), !_this.props.builder.fetchingForms && _this.props.builder.existingLeadForms.length === 0 && /*#__PURE__*/React.createElement("p", null, "You do not have any exiting lead forms yet."), _this.props.isLoadingFormDetail && /*#__PURE__*/React.createElement(Spinner, null)))];
    });

    _this.state = {
      anchorEl: null
    };
    return _this;
  }

  _createClass(LeadFormBuilder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getExistingForms();
    }
  }, {
    key: "render",
    value:
    /*
      RENDER
    */
    function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          builder = _this$props3.builder,
          organization = _this$props3.organization,
          theme = _this$props3.theme;

      var _ref9 = function () {
        if (builder) {
          var _validatorResult = leadFormValidator(builder);

          var form = _validatorResult.form,
              intro = _validatorResult.intro,
              questions = _validatorResult.questions,
              privacyPolicy = _validatorResult.privacyPolicy,
              thankYou = _validatorResult.thankYou,
              settings = _validatorResult.settings;
          return _objectSpread({
            continueEnabled: form.length === 0 && intro.length === 0 && questions.length === 0 && privacyPolicy.length === 0 && thankYou.length === 0 && settings.length === 0
          }, _validatorResult);
        }

        return {
          continueEnabled: false,
          form: [],
          intro: [],
          questions: [],
          privacyPolicy: [],
          thankYou: [],
          settings: []
        };
      }(),
          continueEnabled = _ref9.continueEnabled,
          validatorResult = _objectWithoutProperties(_ref9, ["continueEnabled"]);

      console.log('validatorResult', validatorResult);
      return /*#__PURE__*/React.createElement(FormProvider, {
        clearOnUnmount: false,
        name: "lead_builder_org_".concat(organization.id),
        defaultState: _objectSpread(_objectSpread({}, initialLeadBuilderState(organization.id)), {}, {
          step: 0,
          fetchingForms: false,
          existingLeadForms: [],
          loadingRemoteForm: false
        })
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Lead Form Builder",
        style: {
          marginLeft: 16,
          marginBottom: 16
        },
        showCrumbs: false
      }), !!builder && !!builder.loadingRemoteForm && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 100
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement("div", {
        style: !!builder && !!builder.loadingRemoteForm ? {
          visibility: 'hidden'
        } : {}
      }, !!builder && builder.step === 1 && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          borderBottom: '1px solid #dfdfdf'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          padding: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.textFieldLabel
      }, "Form name"), /*#__PURE__*/React.createElement(TextField, {
        hintText: "Name your form (Required)",
        value: this.props.builder.formName,
        fullWidth: true,
        onChange: function onChange(_ref10) {
          var target = _ref10.target;
          return _this2.props.changeField(_this2.props.builderFormName, 'formName', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0.2,
          padding: '1rem',
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          width: '100%'
        },
        secondary: true,
        disabled: this.props.isCreatingAd || this.props.builder.isSavingForm || !continueEnabled,
        label: this.props.isCreatingAd || this.props.builder.isSavingForm ? /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }) : 'Save Form',
        onClick: this.handleSubmit
      })))), !!builder && builder.step === 1 && builder.asyncErrors && builder.asyncErrors.createdForm && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 10,
          color: 'red'
        }
      }, /*#__PURE__*/React.createElement("p", null, "Your Lead Form has errors:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, builder.asyncErrors.createdForm.message))), this.props.adCreateError && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 10,
          color: 'red'
        }
      }, /*#__PURE__*/React.createElement("p", null, "Failed to create ad:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, this.props.adCreateError))), /*#__PURE__*/React.createElement("div", {
        className: styles.rootWrap,
        style: !!builder && !!builder.loadingRemoteForm ? {
          visibility: 'hidden'
        } : {}
      }, !!builder && builder.step === 0 && this.renderCreationChoices(), !!builder && !builder.isLoadingExistingForms && builder.step === 1 && this.renderLeftPanel(validatorResult), !!builder && builder.isCreatingNewForm && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-0 col-sm-4 ".concat(styles.colExtraPadding),
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(LeadFormPreview, {
        changeField: function changeField(field, value) {
          _this2.props.changeField(_this2.props.builderFormName, field, value);
        },
        builder: builder,
        accordionTab: builder ? builder.contentAccordionTab : 0
      })))));
    }
  }]);

  return LeadFormBuilder;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired
}), _temp)) || _class);
export default LeadFormBuilder;